import { parsePublishedArtifactRawData } from '@/pages/home/utils/publishedArtifact';

import type { AppPlazaArtifactItem, AppPlazaListItem } from './types';

/** 将 ophub 制品项解析为应用广场列表可用的版本视图模型 */
export function publishedArtifactToAppPlazaItem(item: AppPlazaArtifactItem): AppPlazaListItem | null {
  const raw = parsePublishedArtifactRawData(item.rawData);
  const versionId = (typeof raw.id === 'string' && raw.id ? raw.id : '') || item.artifactId || '';
  const parentArtifactId = typeof raw.abstractId === 'string' && raw.abstractId ? raw.abstractId : '';

  if (!versionId || !parentArtifactId) {
    return null;
  }

  return {
    ...(raw as AppPlazaListItem),
    id: versionId,
    abstractId: parentArtifactId,
    parentArtifactId,
    name: raw.name ?? item.name ?? '',
    description: raw.description ?? item.description,
    version: raw.version ?? item.version ?? '',
    vendor: raw.vendor ?? item.vendor ?? '',
    createTime: raw.createTime ?? item.createdAt ?? '',
    updateTime: raw.updateTime ?? item.updatedAt ?? '',
    options: raw.options ?? {},
    // 无 SKU 下单路径需要数据中心
    ...(item.datacenter ? { datacenter: item.datacenter } : {}),
  } as AppPlazaListItem & { datacenter?: string };
}

/** 批量转换列表响应 */
export function mapAppPlazaListItems(items: AppPlazaArtifactItem[] = []): AppPlazaListItem[] {
  return items.map(publishedArtifactToAppPlazaItem).filter((item): item is AppPlazaListItem => !!item);
}
